import React from 'react';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';

const GalleryToasts = (props) => {
  return (
    <div >
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Maritha Hellem</ToastHeader>
          <ToastBody>Gratulerer med 30 årsdagen <span role="img" aria-label="heart"> ❤️ </span></ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Erlend Stenhjem</ToastHeader>
          <ToastBody>Gratulerer med dagen</ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
        <ToastHeader icon="info">Kenneth Aasbø</ToastHeader>
          <ToastBody>Gratulerer med dagen</ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Anne-Mette Sjønnesen</ToastHeader>
          <ToastBody>Gratulerer med dagen</ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Per Arve Sveum</ToastHeader>
          <ToastBody>Gratulerer med dagen</ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Øystein B Østby</ToastHeader>
          <ToastBody>Gratulerer med dagen</ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Roar Angeltveit</ToastHeader>
          <ToastBody>Hipp hipp hurra - Martine<span role="img" aria-label="party">  🎉 </span> </ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Øystein V Jakobsen</ToastHeader>
          <ToastBody><span role="img" aria-label="party"> ☺ 🍾 🥂</span></ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Bjørn Eirik Svendsen</ToastHeader>
          <ToastBody><span role="img" aria-label="party"> ☺ 🍾 🥂</span> </ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Simen Tøien</ToastHeader>
          <ToastBody>Gratulerer med dagen</ToastBody>
        </Toast>
      </div>
      <div className="p-3 my-2 rounded bg-docs-transparent-grid">
        <Toast>
          <ToastHeader icon="info">Øystein Sæle</ToastHeader>
          <ToastBody>Alltid med smilet på lur, bestemt og sta på den gode måten, vinnerinnstinkt, og fullstending crazy fartsgal på alpinski!</ToastBody>
        </Toast>
      </div>


    <div className="p-3 my-2 rounded bg-docs-transparent-grid">
      <Toast>
        <ToastHeader icon="info">Amund Sveipe Waalen</ToastHeader>
        <ToastBody><span role="img" aria-label="alpine"> ⛷️</span></ToastBody>
      </Toast>
    </div>

    <div className="p-3 my-2 rounded bg-docs-transparent-grid">
      <Toast>
        <ToastHeader icon="info">Eli Myren Bjørnsrud</ToastHeader>
        <ToastBody>Gratulerer med 30 år; klem fra Eli<span role="img" aria-label="alpine">  ⛷️ </span> </ToastBody>
      </Toast>
    </div>

    <div className="p-3 my-2 rounded bg-docs-transparent-grid">
      <Toast>
        <ToastHeader icon="info">Helge Kvamme</ToastHeader>
        <ToastBody>Gratulerer med dagen</ToastBody>
      </Toast>
    </div>

    <div className="p-3 my-2 rounded bg-docs-transparent-grid">
      <Toast>
        <ToastHeader icon="info">Maria Camilla Nørgaard</ToastHeader>
        <ToastBody>Gratulerer til Martine 3.0! Takk for at du har tatt meg under vingen i aplingruppa og er en sånn bra person <span role="img" aria-label="smile"> ☺ </span></ToastBody>
      </Toast>
    </div>

    <div className="p-3 my-2 rounded bg-docs-transparent-grid">
      <Toast>
        <ToastHeader icon="info">Mona Bakken</ToastHeader>
        <ToastBody>Gratulerer med dagen</ToastBody>
      </Toast>
    </div>

    <div className="p-3 my-2 rounded bg-docs-transparent-grid">
      <Toast>
        <ToastHeader icon="info">Mona Klikenberg</ToastHeader>
        <ToastBody>Så gøy at du fyller rundt år - hipp hipp hurra, Martine <span role="img" aria-label="rose"> 🌹</span> </ToastBody>
      </Toast>
    </div>

    <div className="p-3 my-2 rounded bg-docs-transparent-grid">
      <Toast>
        <ToastHeader icon="info">Pål Ørving</ToastHeader>
        <ToastBody>Gratulerer med dagen</ToastBody>
      </Toast>
    </div>

    <div className="p-3 my-2 rounded bg-docs-transparent-grid">
      <Toast>
        <ToastHeader icon="info">Lena Holt</ToastHeader>
        <ToastBody>Tusen takk for at du har tatt meg så godt i mot<span role="img" aria-label="heart"> ❤️ </span>. Gratulerer til fine Martine!</ToastBody>
      </Toast>
    </div>
    <div className="p-3 my-2 rounded bg-docs-transparent-grid">
      <Toast>
        <ToastHeader icon="info">Helene Sæthre Evensen</ToastHeader>
        <ToastBody><span role="img" aria-label="giftbox">🎁</span></ToastBody>
      </Toast>
    </div>

</div >

  );
};

export default GalleryToasts;
